var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeliveryProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#37C07E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1068.417 2180.636v8.728h-8.75v-2.91h-7.292c-.804 0-1.458.654-1.458 1.455v5.818c0 .803.654 1.455 1.458 1.455h13.125v-2.91l8.75 4.364-8.75 4.364v-2.91h-13.125c-2.412 0-4.375-1.957-4.375-4.363v-5.818c0-2.406 1.963-4.364 4.375-4.364h7.292v-2.909h8.75zm14.583 11.637V2201h-8.75v-8.727h8.75zm-2.917 2.909h-2.916v2.909h2.916v-2.91zM1056.75 2169v2.91h21.875c2.412 0 4.375 1.957 4.375 4.363v5.818c0 2.406-1.963 4.364-4.375 4.364h-1.458v2.909l-8.75-4.364 8.75-4.364v2.91h1.458c.805 0 1.458-.654 1.458-1.455v-5.818c0-.802-.653-1.455-1.458-1.455h-21.875v2.91H1048V2169h8.75zm8.75 14.545h-2.917v2.91h2.917v-2.91zm-11.667-11.636h-2.916v2.91h2.916v-2.91z",
    transform: "translate(-1048 -2169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliveryProcess);
export default __webpack_public_path__ + "static/media/icon-delivery-process.b20ae284e289f0a228432021fb695bf5.svg";
export { ForwardRef as ReactComponent };